module.exports = __webpack_public_path__ + "static/media/Kravi_hora_Zahradky.29c24894.md";